var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3206 6.63334L20.9465 0H5.37405L0 6.63334",
    fill: "#84FFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.63339L13.1602 24.9975L26.3206 6.63339",
    fill: "#54C0EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5498 6.63339L13.1604 24.9975L21.7712 6.63339",
    fill: "#84FFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7712 6.63334L18.2597 0H8.06123L4.5498 6.63334",
    fill: "#54C0EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.4279 6.63334L15.0844 0H11.237L9.89355 6.63334",
    fill: "#84FFFF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89355 6.63339L13.1607 24.9975L16.4279 6.63339",
    fill: "#54C0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.e9869d2f2f52da846f02072dc51c3303.svg";
export { ForwardRef as ReactComponent };